module.exports = __webpack_public_path__ + "res/7-img_more_rtl.cbe0de14f2c6b10d83f0a7785a9a0e5a.png";